import { render, staticRenderFns } from "./calendar-header.vue?vue&type=template&id=79a8ea12&scoped=true&"
import script from "./calendar-header.vue?vue&type=script&lang=js&"
export * from "./calendar-header.vue?vue&type=script&lang=js&"
import style0 from "./calendar-header.vue?vue&type=style&index=0&id=79a8ea12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a8ea12",
  null
  
)

export default component.exports